import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface UserActivity {
  date: string;
  activity: string;
  type: string;
}

export interface UserActivityPageInfo {
  startCursor: string;
  endCursor: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  total: number;
}

export interface GetUserActivityResponse {
  activities: UserActivity[];
  total: number;
  pageInfo: UserActivityPageInfo;
}

const GET_USER_ACTIVITY = gql`
  query GetUserActivity(
    $userId: Int!
    $pagination: UserActivityPaginationArgs
  ) {
    getUserActivity(userId: $userId, pagination: $pagination) {
      activities {
        date
        activity
        type
      }
      total
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        total
      }
    }
  }
`;

export const getUserActivity = async (
  userId: number,
  first: number = 10,
  after?: string,
): Promise<GetUserActivityResponse> => {
  const pagination: any = { first };
  if (after) pagination.after = after;
  const { data } = await apolloClient.query<{
    getUserActivity: GetUserActivityResponse;
  }>({
    query: GET_USER_ACTIVITY,
    variables: { userId, pagination },
    fetchPolicy: 'network-only',
  });
  return data.getUserActivity;
};
